// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action--2Qu3G379 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  font-size: 24px;\n  color: rgba(255, 255, 255, 0.4);\n  position: relative;\n  transition: none;\n}\n\n.action--2Qu3G379.active--36REBvUG::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 2px;\n  background-color: white;\n}\n\n.action--2Qu3G379.active--36REBvUG,\n.action--2Qu3G379:hover {\n  color: white;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"action": "action--2Qu3G379",
	"active": "active--36REBvUG"
};
export default ___CSS_LOADER_EXPORT___;
